import { call, put, all, takeLatest } from "redux-saga/effects";
import { Api } from "../api";
import * as elementClassificationActions from "../actions/element-classification";
import * as generalActions from "../actions/general";
import * as authActions from "../actions/auth";


function* getIncidentImages(action) {
  try {
    const res = yield call(Api.elementClassification.getIncidentImages, action.payload);
    yield put({
      type: elementClassificationActions.GET_INCIDENT_IMAGES_SUCCESS,
      payload: res.data.data,
    });
  } catch (err) {
    yield put({
      type: elementClassificationActions.GET_INCIDENT_IMAGES_FAIL,
      payload: { error: err.message },
    });
    if (err?.response?.status === 401) yield put({ type: authActions.AUTH_LOGOUT_REQUEST });
  }
}

export default all([
  takeLatest(elementClassificationActions.GET_INCIDENT_IMAGES_REQUEST, getIncidentImages),
  ]
);
